export const isNodeEnv=()=>typeof window==='undefined'||typeof document==='undefined';